import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";
import { LoginButton } from "@/components/auth/LoginButton";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Loading } from "@/components/ui/loading";

/**
 * LoginPage Component
 *
 * Login page that displays Auth0 login button.
 * Redirects to home if already authenticated.
 */
export function LoginPage() {
  const { isAuthenticated, isLoading } = useAuth0();

  // If already authenticated, redirect to home
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-2">
          <CardTitle className="text-3xl">Welcome to EarlyCore</CardTitle>
          <CardDescription className="text-base">
            Please sign in to continue to your account
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <LoginButton />
        </CardContent>
      </Card>
    </div>
  );
}
